var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drop",on:{"dragover":function($event){$event.preventDefault();},"drop":_vm.onDrop}},[_c('label',{staticClass:"btn display-inline"},[_vm._v(" PRZECIĄGNIJ I UPUŚĆ LUB "),_c('input',{ref:"fileInput",attrs:{"type":"file","name":"value"},on:{"change":_vm.onChange}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }